// Abstract text helpers (VA1).
//
// The chatbot / bridge store applicants.abstract as PLAIN text with "\n" line
// breaks. Quill only understands HTML; handing it plain text made every line
// break collapse into a single <p>. These helpers keep paragraphs intact.

const HTML_TAG = /<\/?[a-z][a-z0-9]*(\s[^>]*)?>/i

export function isHtml (text) {
  return typeof text === 'string' && HTML_TAG.test(text)
}

function escapeHtml (s) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

// Plain text -> Quill-native HTML: one <p> per line, a blank line becomes an
// empty Quill line (<p><br></p>) so blank-line paragraph separation survives.
// HTML input is returned untouched.
export function toEditorHtml (text) {
  if (!text) return ''
  if (isHtml(text)) return text
  return text
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map(line => (line.trim() === '' ? '<p><br></p>' : `<p>${escapeHtml(line)}</p>`))
    .join('')
}

// Compare two abstracts by their visible words only (ignores markup,
// alignment classes and whitespace differences).
export function abstractFingerprint (text) {
  if (!text) return ''
  return String(text)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/p>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim()
}
